import I18n from '/src/utils/translations'
import { dispatch } from '/src/hooks/bus/bus'
import BusEvents from '/src/hooks/bus/bus_events'
import { notifySuccess, notifyError } from '/src/ui/core/dialogs/notifications'

// eslint-disable-next-line max-lines-per-function
export default function useRequestConfirmationPopup(showConfirmation) {
  const showActionConfirmation = (dataItem, requestParams, opts) => {
    let actionButtonText = I18n.t(`actions.${opts.actionName}`)
    let cancelButtonText = I18n.t('actions.cancel')
    if (opts.actionText) actionButtonText = opts.actionText
    if (opts.cancelText) cancelButtonText = opts.cancelText

    const actionSuccess = (responseData) => {
          if (opts.batch) {
            const { successes = [], errors = [] } = responseData ?? {}

            if (successes.length) {
              notifySuccess (I18n.t(`requests.notification.batch_confirm_successes`, {quantity: successes.length}))
            }
    
            if (errors.length) {
              notifyError((I18n.t('requests.notification.batch_confirm_errors'), {quantity: errors.length}))
            }
    
          } else {
            const defaultSuccessMessage = I18n.t('notification.action_success', {
              action: I18n.t(`actions.past.${opts.actionName}`),
              model: I18n.t('requests.title'),
              id: dataItem.id
            })
            notifySuccess(opts.customSuccessMessage || defaultSuccessMessage)
          }
    
          return dispatch(BusEvents.RELOAD_GRID)
        }
    
    const onCancel = () => {
      return dispatch(BusEvents.RELOAD_GRID)
    }
    
    const modal_description = opts.batch ? `requests.confirmation_modal.description` : `requests.confirmation_modal.${opts.actionName}_description`

    const actionParams = {
      title: I18n.t(`requests.confirmation_modal.${opts.actionName}_title`),
      description: I18n.t(modal_description),
      actionButtonText,
      cancelButtonText,
      buttonColor: opts.buttonColor ? opts.buttonColor : '#B33939',
      onSuccess: () => actionSuccess,
      onCancel: () => onCancel,
      requestParams,
      batch: true,
    }

    return showConfirmation(actionParams)
  }

  return showActionConfirmation
}